// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import enterWifiMenuImg from "src/assets/images/operating-manual/virtual-reality-device/enter-wifi-menu.png";
import quitPausedAppImg from "src/assets/images/operating-manual/virtual-reality-device/quit-paused-app.png";
import selectNetworkImg from "src/assets/images/operating-manual/virtual-reality-device/select-network.png";
import enterPasswordImg from "src/assets/images/operating-manual/virtual-reality-device/enter-password.png";
import wifiConnectedImg from "src/assets/images/operating-manual/virtual-reality-device/wifi-connected.png";
import resumeAppImg from "src/assets/images/operating-manual/virtual-reality-device/resume-app.png";

const SetUpWifi = () => {
  const { t } = useTranslation("operating-manual");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Typography>
        1.{" "}
        {t("Turn on the headset and the right controller. Put on the headset.")}
      </Typography>

      <Typography>
        2. {t("Press the power / admin menu button quickly.")}
      </Typography>

      <Grid container>
        <Grid container xs={12} sm={8}>
          <Typography>
            3.{" "}
            {t(
              "You should be in a garden background and see a menu screen that looks like this. Point the controller beam at the 'Wi-Fi' section and squeeze the trigger to confirm."
            )}
          </Typography>
        </Grid>
        <Grid container xs={12} sm={4}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: { xs: "20px", sm: "0px" },
            }}
          >
            <img src={enterWifiMenuImg} width="100%" alt="enter-wifi-menu" />
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid container xs={12} sm={8}>
          <Typography>
            4.{" "}
            {t(
              "You may be asked if you want to quit the paused app. Select 'Yes' and squeeze the trigger to confirm."
            )}
          </Typography>
        </Grid>
        <Grid container xs={12} sm={4}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: { xs: "20px", sm: "0px" },
            }}
          >
            <img src={quitPausedAppImg} width="100%" alt="quit-paused-app" />
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid container xs={12} sm={8}>
          <Typography>
            5.{" "}
            {t(
              "Select the Wi-Fi network you would like to connect to from the 'Available Networks' menu."
            )}
          </Typography>
        </Grid>
        <Grid container xs={12} sm={4}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: { xs: "20px", sm: "0px" },
            }}
          >
            <img src={selectNetworkImg} width="100%" alt="select-network" />
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid container xs={12} sm={8}>
          <Typography>
            6. {t("Enter the password to your Wi-Fi and press 'Join'.")}
          </Typography>
        </Grid>
        <Grid container xs={12} sm={4}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: { xs: "20px", sm: "0px" },
            }}
          >
            <img src={enterPasswordImg} width="100%" alt="enter-password" />
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid container xs={12} sm={8}>
          <Typography>
            7. {t("The Wi-Fi should now say 'Connected'.")}
          </Typography>
        </Grid>
        <Grid container xs={12} sm={4}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: { xs: "20px", sm: "0px" },
            }}
          >
            <img src={wifiConnectedImg} width="100%" alt="wifi-connected" />
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid container xs={12} sm={8}>
          <Typography>
            8.{" "}
            {t(
              "Point the controller at the 'Resume App' button in the very bottom left of the screen and squeeze the trigger to confirm. This will take you back to the application."
            )}
          </Typography>
        </Grid>
        <Grid container xs={12} sm={4}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: { xs: "20px", sm: "0px" },
            }}
          >
            <img src={resumeAppImg} width="100%" alt="resume-app" />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SetUpWifi;
